import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'
import ScrollTrigger from 'gsap/ScrollTrigger'

const SELECTORS = {
  grid: '.js-parallax-grid',
  parallaxWrapper: '.js-parallax-wrapper',
  media: '.js-media-image, .js-media-video'
}

class ParallaxGrid {
  constructor (element) {
    this.element = element
    this.wrappers = this.element.querySelectorAll(SELECTORS.parallaxWrapper)
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER

    this.init()
  }

  init() {
    this.calculateSizes()
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, () => this.calculateSizes())
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.IS_MOBILE, ({ isMobile }) => {
      this.setAnimations(isMobile)
    })
  }

  setAnimations(isMobile) {
    const parallaxAnimations = ScrollTrigger
      .getAll()
      .filter(x => x.trigger.classList.contains(SELECTORS.grid.slice(1)))

    if (isMobile) {
      // Use the fade/up transition and not the parallax animation.
      for (const animation of parallaxAnimations) {
        const cards = animation.trigger.querySelectorAll('[data-speed]')
        animation.disable(true, false)
        cards.forEach(card => {
          card.style.transform = ''
          card.classList.add('transition--in-up')
        })
      }
    } else {
      // Use the parallax animation and not the fade.up transition.
      for (const scrollTrigger of parallaxAnimations) {
        const cards = scrollTrigger.trigger.querySelectorAll('[data-speed]')
        scrollTrigger.enable()
        cards.forEach(card => {
          card.classList.remove('transition--in-up')
        })
      }
    }
  }

  calculateSizes() {
    const parentTop = this.element.getBoundingClientRect().top
    const absHeights = []
    this.wrappers.forEach(wrapper => {
      const item = wrapper.querySelector(SELECTORS.media)
      const rect = item.getBoundingClientRect()
      const height = rect.height
      const topOffset = rect.top - parentTop
      const transformY = this.getTransformY(wrapper)
      absHeights.push(height + topOffset - transformY)
    })
    this.element.style.setProperty('--grid-height', `${Math.max(...absHeights)}px`)
  }

  getTransformY(elem) {
    const style = getComputedStyle(elem)
    const matrix = style.transform || style.webkitTransform || style.mozTransform
    const matrixType = matrix.includes('3d') ? '3d' : '2d'
    const matrixArray = matrix.match(/matrix.*\((.+)\)/)
    if (matrixArray) {
      const matrixValues = matrixArray[1].split(', ')
      if (matrixType === '2d') {
        return matrixValues[5]
      } else if (matrixType === '3d') {
        return matrixValues[13]
      }
    }

    return 0
  }
}

export default {
  selector: SELECTORS.grid,
  Source: ParallaxGrid
}
